import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TypeColumn } from '@inovua/reactdatagrid-community/types';

import { useGetParticipantDisplayValue } from '@app/participant-fields';
import {
  ExtendedParticipantField,
  ParticipantFieldCategory,
  useExtendedParticipantFieldsByCategory,
} from '@app/api';
import { useGetFiltersComp } from './useFiters';

const categories = Object.values(ParticipantFieldCategory).map((category) => ({
  name: category,
  header: category,
}));

export const useParticipantColumns = (panelId?: string) => {
  const participantFields = useExtendedParticipantFieldsByCategory();
  const getParticipantDisplayValue = useGetParticipantDisplayValue(panelId);
  const getFiltersComp = useGetFiltersComp();

  return useMemo(() => {
    const res = categories.reduce((acc: TypeColumn[], category) => {
      if (!participantFields) {
        return acc;
      }
      const fields: ExtendedParticipantField[] =
        participantFields[category.name as string];

      return acc.concat(
        fields?.map((field) => {
          return {
            name: field.name,
            header: field.range?.label || field.label,
            group: field.category,
            render: (args: any) => {
              return getParticipantDisplayValue(args.data, field);
            },
            defaultWidth:
              field.category === ParticipantFieldCategory.STATS ? 90 : 180,
            ...getFiltersComp(field),
          };
        }) || [],
      );
    }, [] as TypeColumn[]);
    res.unshift({
      name: 'id',
      header: 'id',
      defaultVisible: false,
      group: 'id',
    });
    return res;
  }, [participantFields, getParticipantDisplayValue, getFiltersComp]);
};
